<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-filter">
        <div class="mc-filter__wrapper">
          <ul class="mc-filter__list">
            <li class="mc-filter__item" :class="sortShow?'isActive':''">
              <button @click="sortShow = true" class="mc-filter__button-sorting js-button-filter simulated-hover" type="button">
                <svg class="mc-filter__button-icon" width="20" height="20" viewBox="0 0 20 20">
                  <use xlink:href="/assets/svg/sprite.svg#icon-sorting"></use>
                </svg>
              </button>
              <div class="mc-filter__body mc-modal">
                <div class="mc-modal__outer">
                  <div class="mc-modal__inner">
                    <div class="mc-modal__heading">
                      <button @click="sortShow = false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                        <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                          <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                        </svg>
                      </button>
                      <div class="mc-modal__title">
                        Сортировка
                      </div>
                    </div>
                    <div class="mc-modal__body">
                      <ul class="mc-filter__option-list mc-options">
                        <li v-for="item in sort" @click="sortProduct(item.id)" class="mc-options__item">
                          <button class="mc-options__button mc-options__button--sm" :class="{isSelected: sortCurrent==item.id}" type="button">
                            {{item.name}}
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="mc-modal__bottom">
                      <button @click="sortShow = false" class="mc-button mc-button--color js-button-close" type="button">
                                                <span class="mc-button__text">
                                                    Закрыть
                                                </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="item in filters" class="mc-filter__item" :class="filterShow==item.id?'isActive':''">
              <button @click="filterShow = item.id" class="mc-filter__button js-button-filter simulated-hover" :class="{isActive:item.isActive}" type="button">
                {{ item.name }}
              </button>
              <button @click="clearFilter(item.id)" class="mc-filter__button-delete js-button-delete" type="button">
                <svg class="mc-filter__button-icon" width="15" height="15" viewBox="0 0 15 15">
                  <use xlink:href="/assets/svg/sprite.svg#icon-cross-2"></use>
                </svg>
              </button>
              <div class="mc-filter__body mc-modal">
                <div class="mc-modal__outer">
                  <div class="mc-modal__inner">
                    <div class="mc-modal__heading">
                      <button class="mc-filter__button-reset js-button-reset" type="button">
                        Сбросить
                      </button>
                      <button @click="filterShow = false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                        <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                          <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                        </svg>
                      </button>
                      <div class="mc-modal__title">
                        {{ item.name }}
                      </div>
                    </div>
                    <div class="mc-modal__body">
                      <ul class="mc-filter__option-list mc-options">
                        <li v-for="value in item.values" class="mc-options__item">
                          <button @click="value.checked = !value.checked" class="mc-options__button" :class="{isSelected: value.checked}" type="button">
                            {{ value.name }}
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="mc-modal__bottom">
                      <button @click="setFilter(); filterShow = false" class="mc-button mc-button--color js-button-close" type="button">
                                                <span class="mc-button__text">
<!--                                                    Показать все 109 товаров-->
                                                  Применить
                                                </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="mc-filter__wrapper" v-if="filterValues.length > 0">
          <ul class="mc-filter__list">
            <li v-for="item in filterValues" class="mc-filter__item">
              <div class="mc-filter__button isActive">
                {{ item.value_name }}
              </div>
              <button @click="clearFilter(item.id, item.value_id)" class="mc-filter__button-delete js-button-delete" type="button">
                <svg class="mc-filter__button-icon" width="15" height="15" viewBox="0 0 15 15">
                  <use xlink:href="/assets/svg/sprite.svg#icon-cross-2"></use>
                </svg>
              </button>
            </li>
            <li class="mc-filter__item">
              <button @click="clearFilter(false)" class="mc-filter__button-clear js-button-clear" type="button">
                Очистить фильтры
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="productsLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="productsError" class="mc-error">{{ productsError }}</div>
      <div v-if="productsLoaded" class="mc-products">
        <div class="mc-products__number">
          {{ product_total }} {{ num_word(product_total, ['товар', 'товара', 'товаров']) }}
        </div>
        <ul class="mc-products__list">
          <li class="mc-products__item" v-for="product in products">
            <product-item :product="product" />
          </li>

        </ul>
      </div>
      <div v-if="loadingMore" class="mc-loader"><span class="mc-loader__circle"></span></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductItem from "./components/ProductItem.vue";
import num from "../mixin/num.vue";
import httpBuildQuery  from "http-build-query";
import queryString from 'query-string';


export default {
    mixins: [num],
    beforeRouteLeave(to, from) {
      window.removeEventListener('scroll', this.handleScroll);
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // vm - это экземпляр компонента
        if (from.name) { // Проверяем, был ли предыдущий маршрут
          console.log('Пришли с маршрута', from.name);
        }
      });
    },
     async created() {
       if (window.performance && window.performance.getEntriesByType) {
         const navigationEntries = window.performance.getEntriesByType('navigation');
         console.log(navigationEntries);
         if (navigationEntries.length > 0) {
           const navEntry = navigationEntries[0];
           if (navEntry.type === 'back_forward') {
             console.log('Переход был выполнен по кнопке Назад/Вперед');
           }
         }
       }
       console.log('created');
      let search = this.$route.query.q ? this.$route.query.q : '';
      let filter = {};

       filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
       delete filter.q;

      this.fetchProducts({id:this.$route.params.id, page:this.currentPage, sort: this.sortCurrent, search:search, filter: filter, first:true});
       await this.fetchFilters({id:this.$route.params.id, search:search, filter:filter, first:true});
       this.updateFilterValues();
      // Add scroll event listener when component is created
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      // Remove scroll event listener when component is destroyed
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      '$route'() {
        let search = this.$route.query.q ? this.$route.query.q : '';
        this.currentPage = 1;
        this.fetchProducts({id:this.$route.params.id, page:this.currentPage, sort: this.sortCurrent, search:search, first:true});
        this.fetchFilters({id:this.$route.params.id, search:search, first:true});
      },
      filterShow(newValue, oldValue) {
        if (newValue)
          document.querySelector("body").classList.add("isMainSearchOpen");
        else
          document.querySelector("body").classList.remove("isMainSearchOpen");
      }
    },
    computed: {
      ...mapGetters([
        'products',
        'section',
        'product_total',
        'productsLoading',
        'productsError',
        'productsLoaded',
        'noMoreProducts',
        'filters',
        'filtersLoading',
        'filtersError',
        'filtersLoaded',
      ]),
    },
    async mounted() {
      // При необходимости можно добавить дополнительную логику
    },
    methods: {
      ...mapActions([
        'fetchProducts',
          'fetchFilters'
      ]),
      /**
       * Handles the scroll event and loads more products when reaching the bottom of the page
       */
      handleScroll() {
        console.log('handleScroll')
        if (this.$route.name != 'category') {
          window.removeEventListener('scroll', this.handleScroll);
        }
        // Calculate if we've reached the bottom of the page
        const bottomOfWindow = Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) + window.innerHeight >= document.documentElement.scrollHeight - 200;

        // If we are at the bottom of the page and not currently loading more products
        if (bottomOfWindow && !this.loadingMore && this.productsLoaded && !this.noMoreProducts) {
          this.loadMoreProducts();
        }
      },

      /**
       * Loads more products when the user scrolls to the bottom of the page
       */
      async loadMoreProducts() {
        // Set loading state
        if (this.loadingMore)
          return;
        this.loadingMore = true;

        // Get current page from store or local state
        const nextPage = this.currentPage + 1;
        let filter = this.getFilter();
        let search = this.$route.query.q ? this.$route.query.q : '';
        await this.fetchProducts({id:this.$route.params.id, page:nextPage, sort: this.sortCurrent, filter: filter, search:search});
        this.loadingMore = false;
        this.currentPage++;
      },
      sortProduct(sort) {
        this.sortCurrent = sort;
        let filter = this.getFilter();
        let search = this.$route.query.q ? this.$route.query.q : '';
        this.fetchProducts({id:this.$route.params.id, page:1, sort: sort, filter:filter, search:search});
      },
      getFilter() {
        let filter = {};
        for (let i in this.filters) {
          for (let j in this.filters[i].values) {
            if (this.filters[i].values[j].checked) {
              if (typeof filter[this.filters[i].code] == 'undefined')
                filter[this.filters[i].code] = [];
              filter[this.filters[i].code].push(this.filters[i].values[j].id);
            }
          }
        }
        return filter;
      },
      async setFilter() {
        let filter = this.getFilter();
        //if (Object.keys(filter).length > 0) {
        let search = this.$route.query.q ? this.$route.query.q : '';

        history.pushState(null, null, '/category/'+this.$route.params.id+'/?q='+search+'&'+httpBuildQuery(filter));



        this.fetchProducts({id:this.$route.params.id, page:1, sort: this.sortCurrent, filter:filter, search:search});
         // await this.fetchFilters({id:this.$route.params.id, search:search, filter:filter});
          this.updateFilterValues();
        //}
        },
      clearFilter(id, value_id=false) {

          let filter = {};
          for (let i in this.filters) {
            for (let j in this.filters[i].values) {
              if (this.filters[i].values[j].checked) {
                if (id == false ||
                    (
                        this.filters[i].id == id
                        && (
                            value_id==false ||
                            value_id == this.filters[i].values[j].id
                        )
                    )
                )
                {
                  this.filters[i].values[j].checked = false;
                }
                else {
                  if (typeof filter[this.filters[i].code] == 'undefined')
                    filter[this.filters[i].code] = [];
                  filter[this.filters[i].code].push(this.filters[i].values[j].id);
                }
              }
            }
          }
        let search = this.$route.query.q ? this.$route.query.q : '';
        history.pushState(null, null, '/category/'+this.$route.params.id+'/?q='+search+'&'+httpBuildQuery(filter));
          this.fetchProducts({id:this.$route.params.id, page:1, sort: this.sortCurrent, filter:filter, search:search});
          this.updateFilterValues();

      },
      updateFilterValues() {
        let filter = [];
        let checked;
        for (let i in this.filters) {
          checked = false;
          for (let j in this.filters[i].values) {
            if (this.filters[i].values[j].checked) {
              checked = true;
              filter.push({
                id: this.filters[i].id,
                value_id: this.filters[i].values[j].id,
                value_name: this.filters[i].values[j].name
              });
            }
          }
          this.filters[i].isActive = checked;
        }
        this.filterValues = filter;
      }
    },
    data: () => ({
      sortShow: false,
      filterShow: false,
      loadingMore: false,
      currentPage: 1,
      filterValues: [],
      sortCurrent: 'new',
      sort: [
        {
          id: 'new',
          name: 'Сначала новые'
        },
        {
          id: 'popular',
          name: 'Сначала популярные'
        },
        {
          id: 'price_asc',
          name: 'Сначала дешевле'
        },
        {
          id: 'price_desc',
          name: 'Сначала дороже'
        },
        {
          id: 'discount',
          name: 'Сначала со скидками'
        },
      ]
    }),
    components: {
      ProductItem
    }
}
</script>
